import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    company: { configurations: url },
  },
} = config

// Configuractions
const getConfiguration = (company, params) => axios.get(url.replace(':idCompany', company), { headers: getHeaders(true), params })
const postConfiguration = (company, configuration) => axios.post(url.replace(':idCompany', company), { configuration }, { headers: getHeaders(true) })
const updateConfiguration = (company, configuration, params) =>
  axios.put(url.replace(':idCompany', company), { configuration }, { headers: getHeaders(true), params })
const deleteConfiguration = (company) => axios.delete(url.replace(':idCompany', company), { headers: getHeaders(true) })

// NightTime
/*
const getNightTime = (company) => axios.get(nightTimeUrl.replace(':idCompany', company), {headers: getHeaders(true)})
const createNightTime = (company, nightTime) => axios.post(nightTimeUrl.replace(':idCompany', company), {nightTime}, {headers: getHeaders(true)})
const updateNightTime = (company, nightTime) => axios.put(nightTimeUrl.replace(':idCompany', company), {nightTime}, {headers: getHeaders(true)})
const removeNightTime = (company) => axios.delete(nightTimeUrl.replace(':idCompany', company), {headers: getHeaders(true)})
*/
export default {
  getConfiguration,
  updateConfiguration,
  postConfiguration,
  deleteConfiguration,
}
